// extracted by mini-css-extract-plugin
module.exports = {"root":"LoadMoreObserver_root__3MwfT","rootCenter":"LoadMoreObserver_rootCenter__3Xze0","noPaddingBottom":"LoadMoreObserver_noPaddingBottom__9OBgv"};